export default function Footer() {
  return (
    <footer className="w-full bg-[#1a1512] py-5 md:py-5">
      <div className="w-full px-6 md:px-12 lg:px-20">
        <div className="max-w-6xl mx-auto">
          <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-stone-600">
              &copy; 2026 Purrfect Pinot Noir. All rights reserved.
            </p>
            <div className="flex items-center gap-5">
              {["instagram", "twitter", "youtube"].map((social) => (
                <a
                  key={social}
                  href="#"
                  className="w-8 h-8 flex items-center justify-center text-stone-500 hover:text-white transition-colors"
                >
                  <i className={`ri-${social}-line text-lg`} />
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}